import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { cn } from '../../lib/utils';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-white/10 rounded-2xl bg-slate-900/50 overflow-hidden mb-4" data-id="element-319">
      <button className="w-full px-6 py-5 flex items-center justify-between text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500" onClick={onClick} aria-expanded={isOpen} data-id="element-320">
        <span className="font-semibold text-lg pr-8 text-slate-100" data-id="element-321">
          {question}
        </span>
        <div className={cn('flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors', isOpen ? 'bg-amber-500/20 text-amber-500' : 'bg-slate-800 text-slate-400')} data-id="element-322">
          {isOpen ? <Minus size={18} data-id="element-323" /> : <Plus size={18} data-id="element-324" />}
        </div>
      </button>
      <AnimatePresence initial={false} data-id="element-325">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-326">
            <div className="px-6 pb-6 pt-0 text-slate-300 leading-relaxed" data-id="element-327">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto" data-id="element-328">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-329" />)}
    </div>;
}